import axios from "axios";
import { z } from "zod";
import { toast } from "../../components/ui/use-toast";
import { CircleCheckBig } from "lucide-react";
const baseUrl = process.env.REACT_APP_SERVER_URL;

export const getAllMessages = async () => {
  try {
    const response = await axios.get(`${baseUrl}/api/contact`);
    return { complaints: response.data.complaints };
  } catch (error) {
    console.error(error);
  }
};

export const getAllPaginatedProjects = async (page: number) => {
  try {
    const response = await axios.get(
      `${baseUrl}/api/projects/all?page=${page}`
    );
    return {
      news: response.data.news,
      count: response.data.count,
      totalPages: response.data.totalPages,
    };
  } catch (error) {
    console.error(error);
  }
};

export const getProjectBySlug = async (slug: string) => {
  try {
    const response = await axios.get(`${baseUrl}/api/projects/slug/${slug}`);
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const handleCreateMessage = async (
  formData: any,
  navigate: Function
) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        "Content-Type": "application/json",
      },
    };

    const response = await axios.post(
      `${baseUrl}/api/contact/`,
      formData,
      config
    );
    toast({
      variant: "destructive",
      className: "bg-green-500 border border-green-500",
      description: (
        <div className="flex items-center">
          <CircleCheckBig className="mr-2" />
          <span className="first-letter:capitalize">
            {response.data.message}
          </span>
        </div>
      ),
    });
    navigate("/");
  } catch (error: any) {
    if (error instanceof z.ZodError) {
      const fieldErrors: { [key: string]: string } = {};
      error.errors.forEach((err: any) => {
        fieldErrors[err.path[0]] = err.message;
      });
    } else {
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        toast({
          variant: "destructive",
          title: "Une erreur s'est produite.",
          description: error.response.data.message,
          className: "bg-red-500 border border-red-500",
        });
        return error.response.data.message;
      }
    }
  }
};

export const handleUpdateMessage = async (
  formData: any,
  EventCreateSchema: any,
  navigate: Function
) => {};

export const deleteMessage = async (id: number) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    };

    const response = await axios.delete(`${baseUrl}/api/contact/${id}`, config);

    toast({
      variant: "destructive",
      className: "bg-green-500 border border-green-500",
      description: (
        <div className="flex items-center">
          <CircleCheckBig className="mr-2" />
          <span className="first-letter:capitalize">
            {response.data.message}
          </span>
        </div>
      ),
    });

    return response;
  } catch (error) {
    console.error(error);
  }
};
